export default __webpack_public_path__ + "static/media/ic-fee.4a88a7db.svg";